import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';;


"use strict";

var viewFriend = Backbone.View.extend({
    initialize: function(opts){
        var self = this; 
    },
    events: {
        
    },

});

export default viewFriend;